import script from "./AspectRatio.vue?vue&type=script&setup=true&lang=ts"
export * from "./AspectRatio.vue?vue&type=script&setup=true&lang=ts"

import "./AspectRatio.vue?vue&type=style&index=0&id=ce18b9f4&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce18b9f4"]])

export default __exports__